module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_karlskrona-cd9072a3c18ad373165a6ea1eb2323d3.png";